import CardDropdown from '@/components/common/CardDropdown';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import Flex from '@/components/common/Flex';
import Avatar, { AvatarGroup } from '@/components/common/Avatar';
import SubtleBadge from '@/components/common/SubtleBadge';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import TextLoading from '../../common/components/skeleton/TextLoading';
import { Button, Card, Dropdown, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toolRoutes } from '@/routes/siteMaps';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery,
} from '@/helpers/utils';

const DomainCardSkeleton = () => {
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);

  return (
    <Row className="g-3 mb-3 mx-0">
      <Card className="p-0">
        <style>{`#dropdown-domain-tools::after{
          display: none;
          }`}</style>
        <FalconCardHeader
          light
          title={
            <Flex className="gap-1" alignItems="start">
              <h5 className="mb-0 fw-bolder text-truncate fs-0">
                <TextLoading width={120} isWidthPx height={12} />
              </h5>

              <SubtleBadge pill bg="secondary" className="fs--2">
                درحال بارگذاری
              </SubtleBadge>
            </Flex>
          }
          titleTag="h5"
          className="py-3"
          endEl={
            <Flex className="gap-2">
              <CardDropdown>
                <Dropdown.Item className="disabled-link">
                  <FontAwesomeIcon icon="user-cog" className="me-1" />
                  مدیریت دسترسی
                </Dropdown.Item>
                <Dropdown.Item className="disabled-link">
                  <FontAwesomeIcon icon="trash-alt" className="fs-1" /> حذف
                </Dropdown.Item>
              </CardDropdown>
            </Flex>
          }
        >
          <div className="fs--2 fw-medium text-400">
            <TextLoading width={75} isWidthPx height={10} />
          </div>
        </FalconCardHeader>
        <Card.Footer className="border-top flex-wrap px-3 align-items-center justify-content-between d-flex bg-body-tertiary p-1">
          <div className="disabled-link">
            <AvatarGroup dense className="mt-2 mb-2">
              {[
                { image: '', name: '...', family: '' },
                { image: '', name: '...', family: '' },
              ].map(({ image, name, family }, index) => (
                <Avatar
                  src={image && image}
                  key={index}
                  name={name || family ? `${name} ${family}` : ''}
                  isExact
                  size="xl"
                  className="border border-3 rounded-circle border-200"
                />
              ))}

              <Avatar
                name={
                  <FontAwesomeIcon
                    icon="user-cog"
                    size="lg"
                    className="me-1 text-primary"
                  />
                }
                isExact
                size="xl"
                className="border border-3 rounded-circle border-200"
              />
            </AvatarGroup>
          </div>
          <Flex
            className="gap-2 disabled-link"
            direction="row"
            alignItems="center"
          >
            {toolRoutes.children.map(tool => (
              <ChildrensTooltip
                delayToRemove={0}
                placement="top"
                key={tool.name}
                html={tool.name}
              >
                <Dropdown.Toggle
                  as={isMdUp ? Button : 'div'}
                  className="position-relative text-primary"
                  variant="falcon-info"
                  size="sm"
                  id="dropdown-domain-tools"
                  style={{
                    color: getColor('navbar-vertical-default-link-active-color'),
                  }}
                >
                  {typeof tool.icon === 'string' ? (
                    <FontAwesomeIcon icon={tool.icon} />
                  ) : (
                    tool.icon
                  )}
                </Dropdown.Toggle>
              </ChildrensTooltip>
            ))}
          </Flex>
        </Card.Footer>
      </Card>
    </Row>
  );
};

export default DomainCardSkeleton;
